/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { AppHeaderScrollableGroup } from '../../../../components/appNav/AppHeaderScrollable';
import ContentFrame from '../../../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../../../components/ScrollAware';
import GroupAboutText from '../common/GroupAboutText';
import GroupEligibilityText from '../common/GroupEligibilityText';
import COLORS from '../../../../styles/Colors';

import { Buttons, Card } from '../../../../../bphComponents/bundle';
import ContentWrapper from '../../../../components/ContentWrapper';
import GroupMetadata, { GroupMetadataType } from '../../../../../models/GroupMetadata';
import GroupBanner from '../GroupDetails/GroupBanner';

interface Props {
  group: GroupMetadataType;
  onGoBack(): void;
  onAccept(): void;
  groupId: number;
  phraseAccept: any;
  phraseConfirmLabel: any;
}
const JoinGroupEligibility: FC<Props> = (props) => {
  const group = new GroupMetadata(props.group);

  return (
    <div>
      <ScrollAwareContext>
        <ScrollAwareAppNavStep
          colorThemeName="group"
          goBack={props.onGoBack}
        />

        <ContentFrame>
          <ScrollAwareScroller>

            <AppHeaderScrollableGroup
              group={props.group}
              groupId={props.groupId}
            />

            <GroupBanner imageBanner={group.imagesBanner.get()} />

            <ContentWrapper>

              <Card.CardShape>
                <Card.CardContent>
                  <GroupAboutText groupId={props.groupId} hasTopPadding backgroundColor={COLORS.grayBackground} />
                </Card.CardContent>
              </Card.CardShape>

              <Card.CardShape>
                <Card.CardContent>
                  <GroupEligibilityText groupId={props.groupId} />
                </Card.CardContent>
              </Card.CardShape>

              <Buttons.PrimaryButton onClick={props.onAccept} className="theme-group base background" alignText="center">
                <FormattedMessage {...props.phraseAccept} />
              </Buttons.PrimaryButton>

              <Card.ExternalCardTitle>
                <FormattedMessage {...props.phraseConfirmLabel} />
              </Card.ExternalCardTitle>
            </ContentWrapper>
          </ScrollAwareScroller>

        </ContentFrame>
      </ScrollAwareContext>
    </div>
  );
};

export default JoinGroupEligibility;
